import { setAccessToken, getAccessToken } from './auth.js'

export const apiFetch = async(url, options = {}) => {
    const res = await fetchConToken(url, options)

    if(res.status === 401){
        console.log('401 en:', url)
        const renovado = await renovarToken()
         console.log('renovado:', renovado)

        if(!renovado) {
            console.log('redirigiendo a login...')
            window.location.href = '/login'
            return
        }

        return fetchConToken(url, options)
    }

    return res
}

export const fetchConToken = async(url, options) => {
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
            Authorization: `Bearer ${getAccessToken()}`,
        }
    })
}

export const renovarToken = async() => {
    try{
        const res = await fetch('http://192.168.1.185:3001/api/auth/refresh', {
            method: 'POST',
            credentials: 'include',
        })

        if (!res.ok) return false

        const data = await res.json()

        setAccessToken(data.accessToken)
        return data
    } catch(err) {
        return false
    }
}